import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { IModalComponent } from '@lib/modal';
import { EMediaDevices } from '@core/services';
import { HcService } from '@project/services';

@Component({
  selector: 'app-media-devices-requires-message-overlay',
  templateUrl: './media-devices-requires-message-overlay.component.html',
  styleUrls: ['./media-devices-requires-message-overlay.component.scss'],
})
export class MediaDevicesRequiresMessageOverlayComponent implements IModalComponent, OnInit {
  @Input() mediaDeviceToAsk: EMediaDevices = null;
  @Input() isDeviceInUse = false;
  @Input() deviceInUseTarget: EMediaDevices = null;

  constructor(public hcService: HcService) {}

  public readonly mediaDevices = EMediaDevices;

  public submit$ = new EventEmitter();
  public close$ = new EventEmitter();

  ngOnInit(): void {}

  public get effectiveDeviceInUseTarget(): EMediaDevices {
    if (this.mediaDeviceToAsk !== EMediaDevices.Both) {
      return this.mediaDeviceToAsk;
    }

    return this.deviceInUseTarget ?? EMediaDevices.Both;
  }

  public get deviceInUseMessageKey():
    | 'video-calls.preview.errors.device-in-use.camera'
    | 'video-calls.preview.errors.device-in-use.microphone'
    | 'video-calls.preview.errors.device-in-use.both' {
    if (this.effectiveDeviceInUseTarget === EMediaDevices.Both) {
      return 'video-calls.preview.errors.device-in-use.both';
    }

    return this.effectiveDeviceInUseTarget === EMediaDevices.Video
      ? 'video-calls.preview.errors.device-in-use.camera'
      : 'video-calls.preview.errors.device-in-use.microphone';
  }

  public onRetryClick(): void {
    this.submit$.emit();
  }
}
